import { MISS_PENALTY } from './config.js';
import { clamp } from './math.js';
export const createStats = () => ({
    score: 0, shotsFired: 0, hits: 0, misses: 0, targetsDestroyed: 0,
    bullseyes: 0, currentStreak: 0, bestStreak: 0, damageContributed: 0,
});
export const accuracyOf = (stats) => stats.shotsFired === 0 ? 0 : stats.hits / stats.shotsFired;
export function recordMiss(stats) {
    stats.shotsFired += 1;
    stats.misses += 1;
    stats.currentStreak = 0;
    stats.score = Math.max(0, stats.score - MISS_PENALTY);
    return -MISS_PENALTY;
}
export function recordHit(stats, input) {
    if (input.countShot !== false) {
        stats.shotsFired += 1;
        stats.hits += 1;
        stats.currentStreak += 1;
        stats.bestStreak = Math.max(stats.bestStreak, stats.currentStreak);
    }
    stats.damageContributed += input.damage;
    if (input.destroyed)
        stats.targetsDestroyed += 1;
    if (input.bullseye)
        stats.bullseyes += 1;
    const distanceBonus = 1 + clamp((input.distance - 18) / 150, 0, 0.65);
    const streakBonus = 1 + Math.min(stats.currentStreak, 12) * 0.025;
    const destroyBonus = input.destroyed ? 1.2 : 1;
    const points = Math.round(input.basePoints * input.ringMultiplier * distanceBonus * streakBonus * destroyBonus);
    stats.score += points;
    return points;
}
export function accuracyBonus(stats) {
    if (stats.shotsFired < 3)
        return 0;
    const accuracy = accuracyOf(stats);
    if (accuracy < 0.55)
        return 0;
    return Math.round(stats.score * Math.pow((accuracy - 0.5) * 0.34, 1.25));
}
//# sourceMappingURL=scoring.js.map